import { IHexGridData, HexGridType } from 'js/bubbleCore/types';
import { Bubble } from 'js/bubbleCore/bubbles/types';
import { spacePositionToPxPosition } from 'js/bubbleCore/view/utils/spacePositionToPxPosition';
import { IHexPixelSize } from 'js/bubbleCore/view/types';
import { Hex } from 'js/bubbleCore/Hex';
import * as PIXI from 'pixi.js';

const tempHexes = Hex.getTempHexes();

export function gridHexToPxPosition(
  grid: IHexGridData<Bubble>,
  col: number,
  row: number,
  hexPixelSize: IHexPixelSize,
  applyOffset: boolean = true,
  out?: PIXI.Point,
): PIXI.Point {
  const {x, y} = tempHexes[grid.type].setOffset(col, row).getPosition()
  const result = spacePositionToPxPosition(x, y, hexPixelSize, out);
  if (applyOffset) {
    const {x: offsetX, y: offsetY} = grid.offset;
    result.x += offsetX * hexPixelSize.width;
    result.y += offsetY * hexPixelSize.height;
  }
  return result;
}